// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agoDeposit-table {
  width: 100%;
}

tbody:before {
  content: "@";
  display: block;
  line-height: 10px;
  text-indent: -99999px;
}


.first_th {
  border-radius: 10px 0 0 10px;
}

.last_th {
  border-radius: 0 10px 10px 0;
}

.agoDeposit_titleComponent {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.delete_filters {
  padding: 5px 10px;
  background-color: var(--bg);
  border-radius: 4px;
  border: solid 1px var(--bg);
  color: var(--text-primary);
}

.delete_filters:hover {
  padding: 5px 10px;
  background-color: #afb7ff;
  border-radius: 4px;
  border: solid 1px var(--primary);
  color: var(--text-primary);
}

/* styles.css (ou le nom de votre fichier CSS) */
.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  width: min-content;
  cursor: pointer;
  outline: none;
}

/* Style de survol lorsque la souris passe sur le select */
.custom-select:hover {
  border-color: var(--border);
}

/* Style de focus lorsque le select est en focus */
.custom-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


th {
  background-color: var(--bg);
  padding: 20px 10px;
  text-align: left;
}

.payout_modalContainer {
  position: block;
  width: 100%;
  height: 100%;
  background-color: aqua;
}

.agoDeposit_filter_component {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
  width: 20%;
}

.agoDeposit_filter_component input {
  width: max-content;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
}

.modal_input_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 100%;
}

.modal_input_container input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 90%;
}

.modal-button-div .valider {
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--primary);
  border: solid 1px var(--primary);
  color: white;
}

.modal-button-div .valider:disabled {
  background-color: rgb(0, 123, 255, 0.7);
  pointer-events: none;
}

.modal_hr_button {
  margin: 20px 0;
}

.agoDeposit_statusSelected {
  background-color: var(--primary) !important;
  color: white !important;
}

.agoDeposit_statusBox {
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px var(--primary);
  color: var(--text-primary);
  background-color: var(--bg-card);
}

.agoDeposit_statusFilters {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  background-color: var(--bg);
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}

.filter_component {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

item_selectMatchingUser {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.linkedUserSelect {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  background-color: var(--bg);
}

.linkedUserNotSelect {
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 4px;
}

.linkedUserSelect p,
.linkedUserNotSelect p {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.users_list_box {
  position: absolute;
  background-color: var(--bg-card);
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 150px;
  overflow-y: scroll;
  width: 100%;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 4px;
}

.input_sleectedUser {
  position: relative;
}

.modal_input_container {
  margin-bottom: 20px;
}

.relative {
  position: relative;
}

.delete_item_select {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.external_deposits_matching_users_box {
  overflow-y: scroll;
  max-height: 450px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ago/AgoDeposits/agoDeposits.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,4BAA4B;EAC5B,gDAAgD;AAClD;;;AAGA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".agoDeposit-table {\n  width: 100%;\n}\n\ntbody:before {\n  content: \"@\";\n  display: block;\n  line-height: 10px;\n  text-indent: -99999px;\n}\n\n\n.first_th {\n  border-radius: 10px 0 0 10px;\n}\n\n.last_th {\n  border-radius: 0 10px 10px 0;\n}\n\n.agoDeposit_titleComponent {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delete_filters {\n  padding: 5px 10px;\n  background-color: var(--bg);\n  border-radius: 4px;\n  border: solid 1px var(--bg);\n  color: var(--text-primary);\n}\n\n.delete_filters:hover {\n  padding: 5px 10px;\n  background-color: #afb7ff;\n  border-radius: 4px;\n  border: solid 1px var(--primary);\n  color: var(--text-primary);\n}\n\n/* styles.css (ou le nom de votre fichier CSS) */\n.custom-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  width: min-content;\n  cursor: pointer;\n  outline: none;\n}\n\n/* Style de survol lorsque la souris passe sur le select */\n.custom-select:hover {\n  border-color: var(--border);\n}\n\n/* Style de focus lorsque le select est en focus */\n.custom-select:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n\nth {\n  background-color: var(--bg);\n  padding: 20px 10px;\n  text-align: left;\n}\n\n.payout_modalContainer {\n  position: block;\n  width: 100%;\n  height: 100%;\n  background-color: aqua;\n}\n\n.agoDeposit_filter_component {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 10px;\n  width: 20%;\n}\n\n.agoDeposit_filter_component input {\n  width: max-content;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.modal_input_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 100%;\n}\n\n.modal_input_container input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 90%;\n}\n\n.modal-button-div .valider {\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--primary);\n  border: solid 1px var(--primary);\n  color: white;\n}\n\n.modal-button-div .valider:disabled {\n  background-color: rgb(0, 123, 255, 0.7);\n  pointer-events: none;\n}\n\n.modal_hr_button {\n  margin: 20px 0;\n}\n\n.agoDeposit_statusSelected {\n  background-color: var(--primary) !important;\n  color: white !important;\n}\n\n.agoDeposit_statusBox {\n  padding: 5px 10px;\n  border-radius: 4px;\n  border: solid 1px var(--primary);\n  color: var(--text-primary);\n  background-color: var(--bg-card);\n}\n\n.agoDeposit_statusFilters {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  background-color: var(--bg);\n  padding: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.filter_component {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\nitem_selectMatchingUser {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.linkedUserSelect {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  background-color: var(--bg);\n}\n\n.linkedUserNotSelect {\n  max-width: 100%;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.linkedUserSelect p,\n.linkedUserNotSelect p {\n  margin: 0;\n  padding: 0;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.users_list_box {\n  position: absolute;\n  background-color: var(--bg-card);\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 150px;\n  overflow-y: scroll;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n}\n\n.input_sleectedUser {\n  position: relative;\n}\n\n.modal_input_container {\n  margin-bottom: 20px;\n}\n\n.relative {\n  position: relative;\n}\n\n.delete_item_select {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  background-color: var(--primary);\n  border-radius: 50%;\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.external_deposits_matching_users_box {\n  overflow-y: scroll;\n  max-height: 450px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
